module.exports = __webpack_public_path__ + "img/ico_book--gray.4bc4fd39.svg";